import type { PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { Appbar } from 'react-native-paper';

import { colorSemantic } from '@/theme/colorSemantic';

const styles = StyleSheet.create({
  base: {
    elevation: 0,
  },
  default: {
    borderBottomWidth: 1,
    borderBottomColor: colorSemantic.colorBorderNdBase,
  },
  dark: {
    backgroundColor: colorSemantic.colorBgNdStrong,
  },
});

interface ScreenAppbarProps extends PropsWithChildren {
  readonly variant?: 'default' | 'dark';
  readonly statusBarHeight?: number;
  readonly testID?: string;
}

export const ScreenAppbar = ({
  children,
  variant = 'default',
  statusBarHeight,
  testID,
}: ScreenAppbarProps) => {
  const isDark = variant === 'dark';

  return (
    <Appbar.Header
      dark={isDark}
      style={[styles.base, isDark ? styles.dark : styles.default]}
      mode="small"
      statusBarHeight={statusBarHeight}
      testID={testID}>
      {children}
    </Appbar.Header>
  );
};
